import store from '@/common/stores/store'
import type { RouteRecordRaw } from 'vue-router'

import i18n from '@/application/i18n/i18n'
import { DHL_DE_CARRIER_RATES_BETA_FLAG, POSTNL_CARRIER_RATES_BETA_FLAG } from '@/features/carrier-rates/beta-features'
import { SETTINGS_CONTRACTS_LIST_ROUTE } from '@/features/carriers/routes'

export const EDIT_CARRIER_RATES_ROUTE = 'carrier-rates.edit'

export default {
  name: EDIT_CARRIER_RATES_ROUTE,
  path: '/contracts/:contractId/rates',
  component: () => import('@/features/carrier-rates/pages/CarrierRatesPage.vue'),
  props: ({ params }) => ({ contractId: +params.contractId }),
  beforeEnter(to, _, next) {
    if (
      !store.getters.hasBetaFeature(POSTNL_CARRIER_RATES_BETA_FLAG) &&
      !store.getters.hasBetaFeature(DHL_DE_CARRIER_RATES_BETA_FLAG)
    ) {
      return next({
        name: SETTINGS_CONTRACTS_LIST_ROUTE,
        params: to.params,
        query: to.query,
        hash: to.hash,
      })
    }

    next()
  },
  meta: {
    pageTitle: () => i18n.t('carrier_rates.page_title'),
    permissions: ['manage_shipping'],
  },
} satisfies RouteRecordRaw
